import { useContext } from 'react';
import EventContext from '../contexts/EventContent';

function useEvent() {
  return useContext(EventContext);
}

export default useEvent;
